var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "box-wrap" },
      [
        _vm.defalutChapter.sealName
          ? _c("div", { staticClass: "temone" }, [
              _c("div", { staticClass: "t-box" }, [
                _c("img", {
                  staticClass: "y-img",
                  attrs: { src: _vm.fileOperShow(_vm.defalutChapter.sealFile) }
                })
              ]),
              _c("p", { attrs: { title: _vm.defalutChapter.sealName } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.defalutChapter.sealName) +
                    "\n      "
                )
              ]),
              _c(
                "p",
                { attrs: { title: "ID:" + _vm.defalutChapter.corpSealId } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s("ID:" + _vm.defalutChapter.corpSealId + ")") +
                      "\n      "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm.chapterList && _vm.chapterList.length > 0
          ? _vm._l(_vm.chapterList, function(item, index) {
              return _c("div", { key: index, staticClass: "temone" }, [
                _c("div", { staticClass: "t-box" }, [
                  _c("img", {
                    staticClass: "y-img",
                    attrs: { src: item.signUrl, title: item.sealName }
                  })
                ]),
                _c("p", { attrs: { title: item.sealName } }, [
                  _vm._v("\n          " + _vm._s(item.sealName) + "\n        ")
                ]),
                _c("p", { attrs: { title: "ID:" + item.corpSealId + ")" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s("ID:" + item.corpSealId) +
                      "\n        "
                  )
                ])
              ])
            })
          : !_vm.defalutChapter.sealName
          ? _c("no-data", {
              staticStyle: { "margin-top": "30px" },
              attrs: { text: "企业暂未授权印章给您，如需使用请联系管理员" }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("授权给我的印章"),
      _c("span", { staticStyle: { "font-size": "14px" } }, [
        _vm._v("\n      / 当前用户的权限范围可使用的印章")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df4387da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df4387da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/seal/giveToMe.vue
// module id = 3yPX
// module chunks = 7 30